import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error module not typed
import { getCitations } from 'conversations-message-history/common-message-format/operators/cmfCitationGetters';
import { LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { ContentTypeIcon } from './ContentTypeIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const areCitationsInMessageText = genericChannelId => {
  // For other channels like WhatsApp, FBM and Email the sources are part of the message content
  return genericChannelId !== LIVE_CHAT_GENERIC_CHANNEL_ID;
};
export const CitationSourcesAttachments = ({
  message
}) => {
  const genericChannelId = getGenericChannelId(message);
  const citationSources = getCitations(message);
  const sourcesArray = citationSources && citationSources.toJS();
  if (!sourcesArray || sourcesArray.length === 0 || areCitationsInMessageText(genericChannelId)) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Text, {
          as: 'small',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.common-message.attachmentRendering.citationSources.title"
          })
        })
      }), /*#__PURE__*/_jsx(List, {
        styled: false,
        children: sourcesArray.map(source => {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(Button, {
              use: "link",
              href: source.deepLink || source.url,
              external: true,
              truncate: true,
              size: "small",
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(ContentTypeIcon, {
                  type: source.hubSpotContentType
                }), source.title || source.url]
              })
            })
          }, source.citationId);
        })
      }), /*#__PURE__*/_jsx(Spacer, {
        space: '100'
      })]
    })
  });
};
CitationSourcesAttachments.displayName = 'CitationSourcesAttachments';